import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import {
  RECEIVE_DATA,
  RECEIVE_TRADE_STRATEGIES,
  RECEIVE_TRADE_STRATEGY_GROUPS,
  REQUEST_DATA,
  REQUEST_TRADE_STRATEGIES,
  REQUEST_TRADE_STRATEGY_GROUPS,
  SET_DEFINITION,
  SET_DEFINITIONS,
} from "./actions";
import SelectionState from "state/selections/SelectionState";
import produce from "immer";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";
import { DELETE_COLUMN } from "state/grid/actions";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  fetchingData: {},
  data: {},
  fetchingTradeStrategyGroups: false,
  tradeStrategyGroups: [],
  fetchingTradeStrategies: false,
  tradeStrategies: [],
  covarMatrixTypes: [
    "SHORT",
    "HISTORICAL",
    "CONSTANT",
    "TOTAL",
    "DAILY",
    "UNKNOWN",
  ],
  errorTypes: ["Correlated", "Isolated", "Unknown"],
  fields: ["totalValue", "yieldValue", "spreadValue", "currencyValue"],
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION:
      return setDefinitionToState(state, action.idx, action.definition);

    case DELETE_COLUMN:
      return removeDefinitionFromState(state, action.payload);

    case SET_DEFINITIONS:
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;

    case COMMIT_SELECTIONS:
      state.data = defaultState.data;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;

    case REQUEST_TRADE_STRATEGY_GROUPS:
      state.fetchingTradeStrategyGroups = true;
      state.tradeStrategyGroups = defaultState.tradeStrategyGroups;
      break;

    case RECEIVE_TRADE_STRATEGY_GROUPS:
      state.fetchingTradeStrategyGroups = false;
      state.tradeStrategyGroups = action.data;
      break;

    case REQUEST_TRADE_STRATEGIES:
      state.fetchingTradeStrategies = true;
      state.tradeStrategies = defaultState.tradeStrategies;
      break;

    case RECEIVE_TRADE_STRATEGIES:
      state.fetchingTradeStrategies = false;
      state.tradeStrategies = action.data;
      break;

    case REQUEST_DATA:
      state.fetchingData[action.payload.key] = true;
      state.data[action.payload.key] = null;
      break;
    case RECEIVE_DATA:
      state.fetchingData[action.payload.key] = false;
      state.data[action.payload.key] = action.payload.data;
      break;

    default:
      return state;
  }
});

export default reducer;
